import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0166',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
